import { render } from "./ReceiverMsg.vue?vue&type=template&id=6d8b9dee&scoped=true"
import script from "./ReceiverMsg.vue?vue&type=script&lang=js"
export * from "./ReceiverMsg.vue?vue&type=script&lang=js"

import "./ReceiverMsg.vue?vue&type=style&index=0&id=6d8b9dee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8b9dee"]])

export default __exports__